import { render } from "./AutoScaleLoadBalancing.vue?vue&type=template&id=039cf5f6&scoped=true"
import script from "./AutoScaleLoadBalancing.vue?vue&type=script&lang=js"
export * from "./AutoScaleLoadBalancing.vue?vue&type=script&lang=js"

import "./AutoScaleLoadBalancing.vue?vue&type=style&index=0&id=039cf5f6&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039cf5f6"]])

export default __exports__